<template>
	<div class="flow-search-result-container" :state="state" :type="type" :fullWidth="fullWidth">
		<div class="flow-search-result-wrapper">
			<div class="flow-search-result">
				<slot />
			</div>
			<div class="flow-search-result-actions">
				<slot name="actions" />
			</div>
		</div>
		<div v-if="$slots['expand-content']" class="flow-search-expandresult" :expanded="expanded">
			<slot name="expand-content" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "SearchResult",
	props: {
		/**
		 * 'bottom-border' | 'transparent'
		 */
		state: {
			type: String,
			default: "bottom-border",
			validator(value) {
				return ["bottom-border", "transparent"].includes(value);
			}
		},
		/**
		 * 'result' | 'header'
		 */
		type: {
			type: String,
			default: "result",
			validator(value) {
				return ["result", "header"].includes(value);
			}
		},
		/**
		 * true | false
		 */
		fullWidth: {
			type: Boolean,
			default: false
		},
		/**
		 * true | false
		 */
		expanded: {
			type: Boolean,
			default: false
		}
	}
});
</script>
<style lang="scss">
div.flow-search-result-container {
	display: flex;
	flex-direction: column;
	// align-items: flex-start;
	// justify-content: space-between;
	width: 400px;

	&[fullWidth] {
		width: 100%;
	}

	background-color: transparent;
	padding: 24px 0px 24px 0px;

	&:first-child {
		padding: 0px 0px 24px 0px;
	}

	&[state="bottom-border"] {
		border-bottom: 1px solid var(--dashboard-border);
	}

	> div.flow-search-result-wrapper {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		flex: 1;
		> div.flow-search-result {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
		}

		> div.flow-search-result-actions {
			display: flex;
			align-items: flex-start;

			> * {
				margin-right: 8px;

				&:only-child,
				&:last-child {
					margin-right: 0px;
				}
			}
		}
	}

	&[type="header"] {
		> div.flow-search-result-wrapper {
			align-items: center;
			> div.flow-search-result {
				align-items: center;
			}
			> div.flow-search-result-actions {
				align-items: center;
			}
		}
	}

	div.flow-search-expandresult {
		max-height: 0px;
		transition: max-height 0.3s;

		display: flex;
		align-items: center;

		overflow: hidden;

		&[expanded] {
			max-height: 50vh;
		}
	}

	@media (max-width: 450px) {
		width: 350px;
	}
}
</style>
